import React from "react";

import "./style.css";

/**
 * Disegna la card a lista a tutta pagina
 */
const ListView = props => {
  const {
    actionsButtons,
    infoListContent,
    leftIcon,
    notificationsBadge,
    onClick,
    titleCatergory
  } = props;

  return (
    <div onClick={onClick ? onClick : () => {}}>
      <div className="list-view-container" >
        <div
          style={{
            padding: "44px 24px 24px 24px"
          }}
        >
          {leftIcon}
        </div>
        <div className="contentBox documentsBox">
          <div style={{ padding: "8px" }}>
            <div >
              <div className="titleDocumentCard">
                {titleCatergory}
              </div>
            </div>
            <div style={{ marginTop: "30px" }}>{infoListContent}</div>
          </div>
        </div>
        {notificationsBadge}
        {actionsButtons}
      </div>
    </div>
  );
};

export default ListView;
